import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=2fc5647e&"
import script from "./RadioInput.vue?vue&type=script&lang=js&"
export * from "./RadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports